module.exports = "<nav class=\"navbar sticky-top navbar-dark bg-dark\">\n    <a class=\"navbar-brand\" href=\"#\">StayTuned</a>\n</nav>\n"